var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sm-text-copy",class:{
    'copied': _vm.justCopied
  },on:{"click":function($event){$event.stopPropagation();return _vm.copyText($event)}}},[_c('span',[_vm._v(_vm._s(_vm.text))]),_c('include-svg',{attrs:{"name":'icon-copy'}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }